import GroupItem from '@/components/descriptors/group-item'

export default {
  name: 'rf-checkbox',
  extends: GroupItem
}
